import { Injectable, signal, Signal, WritableSignal } from "@angular/core";
import { toObservable } from "@angular/core/rxjs-interop";
import { TOAST_DURATIONS } from "@core/types/toast/toast.types";
import { StatusType } from "@shared/types/status.types";
import { TranslationInfo } from "@shared/types/translation-info";
import { filter, Observable, switchMap, tap, timer } from "rxjs";


const TOAST_DURATION_MS: number = TOAST_DURATIONS.LONG;

// Todo check if used in other components and generalize
export interface ComponentToast {
  status: StatusType;
  localizedText: TranslationInfo;
}
@Injectable()
export class ComponentToastService {
  // eslint-disable-next-line @unicorn/no-useless-undefined
  private _toast: WritableSignal<ComponentToast | undefined> = signal(undefined);

  private _toast$: Observable<ComponentToast | undefined> = toObservable(this._toast);

  public toast: Signal<ComponentToast | undefined> = this._toast.asReadonly();

  constructor () {
    this._toast$
      .pipe(
        filter((toast: ComponentToast | undefined): toast is ComponentToast => toast !== undefined),
        switchMap(() =>
          timer(TOAST_DURATION_MS).pipe(
            tap(() => this._toast.set(undefined))
          ))
      )
      .subscribe();
  }

  hideToast (): void {
    this._toast.set(undefined);
  }

  // eslint-disable-next-line @tseslint/no-shadow
  showToast (status: StatusType, localizedText: TranslationInfo): void {
      this._toast.set({ status, localizedText });
  }
}